import React from "react";

interface EdecideParticipantRowProps {
  participant: string;
  index: number;
}

export const EdecideParticipantRow: React.FC<EdecideParticipantRowProps> = ({ participant, index }) => {
  return (
    <tr key={`participant-${index}`}>
      <td>{participant}</td>
    </tr>
  );
};
